import { CHECK_SIZE, SEND_ROUTE } from './../actions/profile';
const initialState = {};

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function profileReducer(state = initialState, action) {
  switch (action.type) {
    case CHECK_SIZE:
      return {
        ...state,
        isMobile: window.screen.width < 768 ? true : false,
        // isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      };
    case SEND_ROUTE:
      return {
        ...state,
        route: action.route,
      };
    default:
      return state;
  }
}
